import type { Point } from '../../shared/contracts.js';

/** Diagram menus use CSS pixels, independent of the surrounding UI scale. */
export function diagramContextMenuFontSize(zoom: number): number {
  const validZoom = Number.isFinite(zoom) && zoom > 0 ? zoom : 1;
  return Math.max(14, Math.min(22, 14 * validZoom));
}

export interface ContextMenuSpace extends Point { width: number; height: number }

/** Screen-visible portion of the canvas, expressed in canvas-relative pixels. */
export function diagramContextMenuSpace(
  canvas: { left: number; top: number; right: number; bottom: number },
  viewport: { width: number; height: number },
): ContextMenuSpace {
  const left = Math.max(0, canvas.left), top = Math.max(0, canvas.top);
  const width = Math.max(0, Math.min(viewport.width, canvas.right) - left);
  const height = Math.max(0, Math.min(viewport.height, canvas.bottom) - top);
  const insetX = Math.min(8, width / 2), insetY = Math.min(8, height / 2);
  return { x: left - canvas.left + insetX, y: top - canvas.top + insetY,
    width: Math.max(1, width - 2 * insetX), height: Math.max(1, height - 2 * insetY) };
}

/** Clamp measured menu dimensions, rather than an estimated fixed-size box. */
export function diagramContextMenuPosition(
  anchor: Point,
  size: { width: number; height: number },
  space: ContextMenuSpace,
): Point {
  return {
    x: Math.max(space.x, Math.min(anchor.x, space.x + Math.max(0, space.width - size.width))),
    y: Math.max(space.y, Math.min(anchor.y, space.y + Math.max(0, space.height - size.height))),
  };
}
